import css from "styled-jsx/css";
import { MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH } from "/constants/vp-sizes";
import { TABLET_QUERY_MAX_WIDTH } from "/constants/vp-sizes";

export const componentStyles = css.global`
  .selectable-tags-grid-component {
    max-width: ${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH + "px"};
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;
